import {SummaryModel} from "../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";
import {InsolesModelSummaryModel} from "../../../../insolemodel/api/entity/insolesModelSummary.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class InsolesProviderModelSummaryModel implements SummaryModel {
    id: number;
    permissions: PermissionsModel;
    code: string;
    label: string;
    symmetryAllowed = false;
    enableForCreation = true;
    camMethod: LovValueSummary;
    billable = true;
    active: boolean;
    index: number;
    providerServiceId: number;

    get manualMethod(): boolean {
        return this.camMethod?.value === 'CAM_METHOD_MANUAL';
    }
}